




































































































/* Created- 19 - Mar - 2019 */
import { Component, Vue, Prop, Watch, Inject } from "vue-property-decorator";
import {
	ListItemDTO,
	ArticleForCurationDTO,
	ArticleModel,
	ApiAuditModel,
	CurationInfoDTO,
	ContentStreamLevelDTO,
	ICurationInfoDTO,
	CurationTodoDTO
} from "@../../../src/Generated/ParticaAPI";
import {
	ParticaConfirmConfig
} from "@../../../src/Models/Components.model";
import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import { NavigationService } from "../../NavigationServices/navigation";
import ActionListV2 from "@/Ui-Components/Common/List/ActionListV2.vue";
import ParticaList2Line from "@/Ui-Components/Common/List/ParticaList2LineV3.vue";
import ParticaArticleCurate from "@/Ui-Components/Article/Curate/ParticaArticleCurate.vue";
import ParticaArticlePreview from "@/Ui-Components/Article/Preview/ParticaArticlePreview.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaColumnContainer from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";
import { ContentStreamCurateService, IContentStreamCurateService } from "../../BusinessServices/contentstreamcurate";
import { ICuratedArticle, Article, IArticle } from "../../Models/ArticleModels/article";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import ParticaCardXl from "@/Ui-Components/Common/Container/ParticaCardXL.vue";
import { ParticaListContent, ParticaListLineContent } from "../../Models/ParticaListModel";
import ParticaConfirmDialog from "@/Ui-Components/Common/ConfirmDialog/ParticaConfirmDialog.vue";
import ContentStreamTodoList from "@/Ui-Components/ContentStream/ContentStreamTodoList.vue";
import { eParticaAction, getActionName, ParticaEvent } from "../../Models/ParticaEvent";
import { ButtonConfig, ButtonType, ButtonStatus } from "../../Models/Buttons";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import ParticaStreamBase from "../Base/ParticaStreamBase.vue";
import { BreadcrumbItem } from "../../Models/Breadcrumb";
@Component({
	name: "ContentStreamTodo",
	components: {
		ParticaError,
		ActionListV2,
		ParticaArticleCurate,
		ParticaArticlePreview,
		ParticaRowContainer,
		ParticaColumnContainer,
		ParticaCard,
		ParticaList2Line,
		ParticaConfirmDialog,
		ContentStreamTodoList,
		ParticaCardXl,
		ParticaView
	}
})
export default class ContentStreamTodo extends ParticaStreamBase {
	private data: CurationTodoDTO[] = [];
	private contentStreamCurateService: IContentStreamCurateService;
	private curatearticle: boolean = false;
	private previewarticle: boolean = false;
	private outstandingwork: ParticaListContent = new ParticaListContent();

	@Prop() private customerAccountId: number;
	@Prop() private contentStreamId: number;
	@Prop() private contentStreamIssueId: number;
	private listdata: ListItemDTO[] = [];
	private article: ICuratedArticle = new Article() as ICuratedArticle;
	private curationInfo: CurationInfoDTO = new CurationInfoDTO(
		{
			level: new ContentStreamLevelDTO(),
			clientInfo: "",
			client: ""
		} as ICurationInfoDTO);

	private curatebuttons: ButtonConfig[] = [
		{ label: "Save Changes", action: eParticaAction.ARTICLE_SAVE, type: ButtonType.OK } as ButtonConfig,
		{
			label: "Complete Tailoring",
			status: ButtonStatus.Enabled,
			action: eParticaAction.CONTENT_STREAM_ARTICLE_CURATION_REQUEST,
			type: ButtonType.OK
		} as ButtonConfig,
		{ label: "Help", action: eParticaAction.SHOW_HELP, type: ButtonType.Clear } as ButtonConfig
	];

	private confirmCurateDialog = {
		title: "Confirm tailoring of this article.",
		message: "Are you sure you want to complete this article? You cannot alter the article if you proceed.",
		show: false
	} as ParticaConfirmConfig;


	private listactions: ButtonConfig[] = [
		{ label: "Tailor", action: eParticaAction.CONTENT_STREAM_CURATE_ARTICLE, type: ButtonType.Clear } as ButtonConfig,
		{ label: "Preview", action: eParticaAction.ARTICLE_PREVIEW, type: ButtonType.Clear } as ButtonConfig
	];

	private async curateArticle() {
		try {
			this.LoadingStart();
			await this.contentStreamCurateService.MarkArticleCurated(this.article.articleId);
			this.init();
			this.ShowSnackbar(`Tailored, subscriber can now view "${this.article.title}"`);
			this.confirmCurateDialog.show = false;
			this.curatearticle = false;
		} catch (error) {
			this.ShowErrorDialog(error, "An error occured. Contact support.");
		} finally {
			this.LoadingEnd();
		}

	}

	private async eventHandler(data: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (data.action) {
				case eParticaAction.PROPERTY_CHANGED: {
					this.SetButtonStatus(this.curatebuttons, eParticaAction.CONTENT_STREAM_ARTICLE_CURATION_REQUEST, ButtonStatus.Disabled);
					break;
				}
				case eParticaAction.ARTICLE_PREVIEW: {
					this.previewarticle = true;
					break;
				}
				case eParticaAction.CONTENT_STREAM_CURATE_ARTICLE: {
					this.article = await this.contentStreamCurateService.getArticleForCuration(data.item.articleId as string);
					this.curationInfo = await this.contentStreamCurateService.GetCurationInfo(data.item.articleId as string);
					this.curatearticle = true;
					break;
				}
				case eParticaAction.ARTICLE_SAVE: {
					this.article = await this.contentStreamCurateService.SaveCuratingArticle(this.article);
					this.ShowSnackbar(`Saved : "${this.article.title}"`);
					this.SetButtonStatus(this.curatebuttons, eParticaAction.CONTENT_STREAM_ARTICLE_CURATION_REQUEST, ButtonStatus.Enabled);
					this.init();
					break;
				}
				case eParticaAction.CONTENT_STREAM_ARTICLE_CURATION_REQUEST: {
					this.confirmCurateDialog.show = true;
					break;
				}
				
				default: {
					this.baseEventHandler(data);
				}
			}
		} catch (e) {
			this.ShowErrorDialog(e, "Error processing event." + data.action);
		} finally {
			this.LoadingEnd();
		}
	}

	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Articles requiring tailoring";
		this.navigationService = new NavigationService();
		await this.init();

	}

	private async init() {
		try {
			this.LoadingStart();
			this.contentStreamCurateService = this.particaServices.getContentStreamCurateService();
			const articleForCurationDTO = new ArticleForCurationDTO();
			articleForCurationDTO.contentStreamId = this.contentStreamId;
			articleForCurationDTO.customerAccountId = this.customerAccountId;
			// articleForCurationDTO.contentStreamIssueId = this.contentStreamIssueId;
			this.data = await this.contentStreamCurateService.GetArticlesForCuration(
				articleForCurationDTO
			);
			this.outstandingwork = await this.contentStreamCurateService.GetOutstandingWorkStats(this.stateconfig.accountid);
			if (this.contentStreamId > 0) {
				await this.getStreamNav(this.contentStreamId);
			} else {
				if (this.breadcrumbs.length === 0) {
					this.breadcrumbs.push(
						{ text: this.metadata.name, to: `/contentstreams/`, exact: true, disabled: true }
					);
				}
			}
		} catch (e) {
			this.ShowErrorDialog(e, "Error getting articles for tailoring.");
		} finally {
			this.LoadingEnd();
		}
	}
}
